import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IQuestionTplType } from '@/shared/model/question-tpl-type.model';

const baseApiUrl = 'api/question-tpl-types';

export default class QuestionTplTypeService {
  public find(id: number): Promise<IQuestionTplType> {
    return new Promise<IQuestionTplType>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IQuestionTplType): Promise<IQuestionTplType> {
    return new Promise<IQuestionTplType>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IQuestionTplType): Promise<IQuestionTplType> {
    return new Promise<IQuestionTplType>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
